'use strict'
define ['./appActionBar.scss'], () ->
  ($q, RentappService, $state, $rootScope, Application, $uibModal, Flash, ApplicationBundle) ->
    restrict: "E"
    template: require("./appActionBar.jade")
    link: (scope, element, attrs) ->
      scope.active_apps_selected = []
      scope.archived_apps_selected = []
      scope.tab_state = 'active'

      scope.can_change_owner = $rootScope.user.can_admin_company

      scope.reset_bar = () ->
        scope.active_apps_selected = []
        scope.archived_apps_selected = []
        scope.show_bar = false

      scope.reset_bar()

      appActionBar = $("app-action-bar")
      stickyFixed = "fixed"
      aboveAppActionBarHeight =  48
      $(window).scroll ->
        if !scope.show_bar
          appActionBar.removeClass stickyFixed
          return

        if $(this).scrollTop() > aboveAppActionBarHeight
          appActionBar.addClass stickyFixed
        else
          appActionBar.removeClass stickyFixed
        return

      scope.$on 'add-app', (event, data) ->
        if scope.tab_state == 'active'
          scope.active_apps_selected.push(data.app)
        else
          scope.archived_apps_selected.push(data.app)
        scope.toggle_bar()

        if scope.show_bar
          $rootScope.$broadcast('show-action-bar')

      scope.$on 'remove-app', (event, data) ->
        if scope.tab_state == 'active'
          _.remove(scope.active_apps_selected, {slug: data.app.slug})
        else
          _.remove(scope.archived_apps_selected, {slug: data.app.slug})
        scope.toggle_bar()

        if !scope.show_bar
          $rootScope.$broadcast('hide-action-bar')

      scope.$on 'switched-tab-state', (event, data) ->
        scope.tab_state = data.state
        scope.toggle_bar()

      scope.toggle_bar = () ->
        if (scope.tab_state == 'active' and scope.active_apps_selected.length) or (scope.tab_state == 'archived' and scope.archived_apps_selected.length)
          scope.show_bar = true
        else
          scope.show_bar = false

      scope.archive_apps = () ->
        scope.is_archiving = true
        promises = []

        for bundle in scope.active_apps_selected
          for app in bundle.applications
            promises.push(Application.update({ id: app.id, is_archived: true }).$promise)

        $q.all(promises)
          .then () ->
            Flash.create('success', 'Applicant successfully archived. Go to "Archived Applicants" to view', 4000, {class: 'archive-success'}, true);
            scope.is_archiving = false
            scope.reset_bar()
            $rootScope.$broadcast 'refresh-appbundle-table'

      scope.unarchive_apps = () ->
        scope.is_unarchiving = true
        promises = []

        for bundle in scope.archived_apps_selected
          for app in bundle.applications
            promises.push(Application.update({ id: app.id, is_archived: false}).$promise)

        $q.all(promises)
          .then () ->
            scope.is_unarchiving = false
            scope.reset_bar()
            $rootScope.$broadcast 'refresh-appbundle-table'
      
      scope.open_change_owner_modal = () ->
        if scope.tab_state == 'active'
          scope.bundles = scope.active_apps_selected
        if scope.tab_state == 'archived'
          scope.bundles = scope.archived_apps_selected
        
        $uibModal.open
          scope: scope
          template: require("./../applicationChangeOwnerModal/applicationChangeOwnerModal.jade")
          controller: require("./../applicationChangeOwnerModal/applicationChangeOwnerModal.coffee")
          windowClass: 'application-change-owner-modal'
        .result.then () ->
          scope.reset_bar()

      scope.open_delete_modal = () ->
        if scope.tab_state == 'active'
          scope.bundles = scope.active_apps_selected
        if scope.tab_state == 'archived'
          scope.bundles = scope.archived_apps_selected

        $uibModal.open
          scope: scope
          template: require("./../applicationDeleteModal/applicationDeleteModal.jade")
          controller: require("./../applicationDeleteModal/applicationDeleteModal.coffee")
          windowClass: 'application-delete-modal'
        .result.then () ->
          scope.reset_bar()

      scope.group_applicants = () ->
        scope.is_grouping = true

        application_ids = []
        for bundle in scope.active_apps_selected
          for app in bundle.applications
            if app.status not in ["S", "A", "R"]
              Flash.create('danger', 'Cannot group invitations or incomplete applications', 4000, null, true);
              return
            application_ids.push(app.id)

        ApplicationBundle.group({ application_ids: application_ids }).$promise
          .then (response) ->
            console.log(response)
            scope.reset_bar()
            $rootScope.$broadcast 'refresh-appbundle-table'
          .catch (err) ->
            console.log(err)
          .finally ->
            scope.is_grouping = false

      scope.ungroup_bundle = () ->
        scope.is_ungrouping = true
        bundle_slug = scope.active_apps_selected[0].slug

        ApplicationBundle.ungroup({ bundle_slug: bundle_slug }).$promise
          .then (response) ->
            console.log(response)
            scope.reset_bar()
            $rootScope.$broadcast 'refresh-appbundle-table'
          .catch (err) ->
            console.log(err)
          .finally ->
            scope.is_ungrouping = false



// WEBPACK FOOTER //
// ./directives/appActionBar/appActionBar.coffee